import React, { useCallback, useState } from "react";
import { Row, Col } from "reactstrap";

import ButtonDisplay from "./inputs/ButtonDisplay";
import CaptchaDisplay from "./inputs/Captcha";

import CellphoneDisplay from "./inputs/CellphoneDisplay";
import CheckboxDisplay from "./inputs/CheckboxDisplay";
import CPFDisplay from "./inputs/CPFDisplay";
import EmailDisplay from "./inputs/EmailDisplay";
import LabelDisplay from "./inputs/LabelDisplay";
import PasswordDisplay from "./inputs/PasswordDisplay";
import NameDisplay from "./inputs/NameDisplay";
import RadioDisplay from "./inputs/RadioDisplay";
import SelectDisplay from "./inputs/SelectDisplay";
import TextDisplay from "./inputs/TextDisplay";
import ThermDisplay from "./inputs/ThermDisplay";
import UploadDisplay from "./inputs/UploadDisplay";
import AgreeDisagreeDisplay from "./inputs/AgreeDisagreeDisplay";
import RatingDisplay from "./inputs/RatingDisplay";
import EmojiDisplay from "./inputs/EmojiDisplay";
import LinkButtonDisplay from "./inputs/LinkButtonDisplay";

const getFieldErrorMessage = (col) => {
  if (col.attributes?.useRawErrorMessage && col.attributes?.errorMessage) {
    return col.attributes.errorMessage;
  }

  const label = col.attributes?.label || col.attributes?.inputName || 'Campo';
  const value = col.attributes?.value;
  const isChoiceField = Array.isArray(col.attributes?.boxes);

  if (col.attributes?.required && isChoiceField) {
    const isEmpty = !value || (Array.isArray(value) ? value.length === 0 : value === '');
    if (isEmpty) return 'Selecione pelo menos uma opção.';
  }

  const isEmpty = value === undefined || value === null || value === '';
  if (col.attributes?.required && isEmpty) {
    return `O campo ${label} é obrigatório.`;
  }

  return `${label} inválido.`;
};

const FormComponent = ({ form, saveForm, setForm, onSubmit, hiddenInputIds = [] }) => {
  const [submitted, setSubmitted] = useState(false);

  const components = useCallback(
    (attributes, rowId, colId) => [
      <TextDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <UploadDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <ThermDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <SelectDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <CheckboxDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <RadioDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <ButtonDisplay
        attributes={attributes}
        saveForm={() => {
          setSubmitted(true);
          typeof onSubmit === "function" && onSubmit();
        }}
      />,
      <EmailDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <CellphoneDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <CPFDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
        submitted={submitted}
      />,
      <LabelDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <CaptchaDisplay rowId={rowId} colId={colId} setValue={setForm} />,
      <PasswordDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <NameDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <AgreeDisagreeDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <RatingDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <EmojiDisplay
        attributes={attributes}
        rowId={rowId}
        colId={colId}
        setValue={setForm}
      />,
      <LinkButtonDisplay attributes={attributes} />,
    ],
    [setSubmitted, onSubmit, submitted]
  );
  return (
    <>
      {form.length > 0 &&
        form?.map((item, index) => (
          <Row className="row-wrapper-form" key={index}>
            {item.cols?.filter((col) => !hiddenInputIds.includes(col.inputId)).map((col) => (
              <Col key={`row/${item.row}/col${col.col}`}>
                {components(col.attributes, item.row, col.col)[col.inputId]}
                {(
                  // useRawErrorMessage = usuário JÁ digitou algo inválido
                  // (ex: email malformado, CPF errado). Mostra desde a
                  // digitação, sem esperar submit — não pressiona campos
                  // vazios porque só é setado quando há valor.
                  (col.attributes.useRawErrorMessage &&
                    col.attributes.errorMessage) ||
                  // Demais erros (obrigatório, validação por regra) só
                  // aparecem após tentar enviar ou se `saveForm` foi
                  // passado (fluxo do ViewForm).
                  ((submitted || saveForm) &&
                    ((col.attributes.required && col.attributes.errorMessage) ||
                      (col.attributes.hasValidation &&
                        col.attributes.errorMessage)))
                ) && (
                  <span style={{ color: "red" }}>
                    {getFieldErrorMessage(col)}
                  </span>
                )}
              </Col>
            ))}
          </Row>
        ))}
    </>
  );
};

export default FormComponent;
